<template>
  <div class="hailingLicenceInfo">
    <QS-h4-title title="网约人证信息" />
    <!-- eslint-disable vue/no-unused-refs -->
    <el-form
      :model="individualCustomerInfo"
      ref="addHailingLicenceInfo"
      label-width="140px"
    >
    <!-- eslint-enable -->
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item prop="hailingLicenceUrl" :label="'网约人证照片（正）' + columnSeparator">
            <UploadCommon
              fileTitle="(ocr识别)"
              :isAlone="true"
              :fileList="hailingLicenceUrl"
              @uploadSuccess="hailingLicenceSuccess"
              @deleteUploadHandle="delHailingLicenceUrl"
              :sizeType="4"
              commonUpload
              group="assert"
              code="assert_online_ride_license_front_pic"
            ></UploadCommon>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- </column-box> -->
      <!-- <column-box :column="3" label-width="150px"> -->
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item
            prop="hailingLicenceCertificateFirstDate"
            label-width="230px"
            :label="'网约车驾驶员证初次领证日期' + columnSeparator"
          >
            <el-date-picker
              v-model="individualCustomerInfo.hailingLicenceCertificateFirstDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            prop="hailingLicenceCertificateStartDate"
            label-width="230px"
            :label="'网约车驾驶员证有效起始日期' + columnSeparator"
          >
            <el-date-picker
              v-model="individualCustomerInfo.hailingLicenceCertificateStartDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item
            prop="hailingLicenceValidDate"
            :label="`网约人证有效期${columnSeparator}`"
          >
            <el-date-picker
              v-model="individualCustomerInfo.hailingLicenceValidDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="hailingLicenceServiceType"
            :label="`服务类型${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="individualCustomerInfo.hailingLicenceServiceType"
              placeholder="请输入"
              clearable
              maxlength="20"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="hailingLicenceCertificateNo"
            :label="`网约车资格证号${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-uppercase="true"
              v-model="individualCustomerInfo.hailingLicenceCertificateNo"
              placeholder="请输入"
              clearable
              maxlength="20"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item
            prop="networkDriverLicense"
            :label="`网约车司机证${columnSeparator}`"
          >
            <el-select
              placeholder="请选择"
              v-model="individualCustomerInfo.networkDriverLicense"
              clearable
            >
              <el-option
                v-for="item in isHaveList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- </column-box> -->
    </el-form>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
import {
  isDate,
} from '@/utils/extendFormVaildate.js'

import {
  getNewwork,
} from '@/api/carManage'

export default {
  props: {
    addFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    addFormData: {
      handler(val) {
        if (val.individualCustomerVo) {
          const { individualCustomerVo } = val
          this.individualCustomerInfo = {
            hailingLicenceUrl: individualCustomerVo.hailingLicenceUrl,
            hailingLicenceValidDate: individualCustomerVo.hailingLicenceValidDate,
            hailingLicenceCertificateFirstDate:
              individualCustomerVo.hailingLicenceCertificateFirstDate,
            hailingLicenceCertificateStartDate:
              individualCustomerVo.hailingLicenceCertificateStartDate,
            hailingLicenceServiceType: individualCustomerVo.hailingLicenceServiceType,
            hailingLicenceCertificateNo: individualCustomerVo.hailingLicenceCertificateNo,
            networkDriverLicense: individualCustomerVo.networkDriverLicense,
          }
          this.hailingLicenceUrl = individualCustomerVo.hailingLicenceUrl || []
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      hailingLicenceUrl: [],
      individualCustomerInfo: {
        hailingLicenceUrl: '', // 网约车人证
        hailingLicenceValidDate: '', // 网约人证有效期
        hailingLicenceCertificateFirstDate: '', // 网约车驾驶员证初次领证日期
        hailingLicenceCertificateStartDate: '', // 网约车驾驶员证有效起始日期
        hailingLicenceServiceType: '', // 服务类型
        hailingLicenceCertificateNo: '', // 网约车资格证号
        networkDriverLicense: '', // 网约车资格证
      },
    }
  },
  computed: {
    // 网约车司机证有无
    isHaveList() {
      return this.dictParseList(selectOption.isHaveList)
    },
  },
  methods: {
    hailingLicenceSuccess(url) {
      this.individualCustomerInfo.hailingLicenceUrl = JSON.stringify([url])
      getNewwork({ imageUrl: url }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const {
            expiryDate,
            licenseNo,
            firstIssueDate,
            issueDate,
            releaseDate,
            startDate,
          } = data
          this.individualCustomerInfo = Object.assign({}, this.individualCustomerInfo, {
            hailingLicenceValidDate: isDate(expiryDate) ? expiryDate : '',
            hailingLicenceCertificateNo: licenseNo,
            hailingLicenceCertificateFirstDate:
              [firstIssueDate, issueDate, releaseDate].find(isDate) || '',
            hailingLicenceCertificateStartDate: isDate(startDate) ? startDate : '',
          })
        }
      })
    },
    delHailingLicenceUrl() {
      this.individualCustomerInfo.hailingLicenceUrl = null
    },
  },
}
</script>

<style lang="scss" scoped>
.hailingLicenceInfo{

}
</style>
